import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getQuizThunk = createAsyncThunk(
  "commonquiz/get",
  async (params) => {
    const { usertype } = params;
    let response = await api.get("getMasterIntroQuiz/" + usertype );
    return response.data;
  }
);

export const createIntroQuizThunk = createAsyncThunk(
  "commonquiz/create",
  async (body) => {
    let response = await api.put("updateMasterIntroQuiz ", body);
    return response.data;
  }
);


export const updateCommonQuizTopicThunk = createAsyncThunk(
  "commonquiz/update",
  async (reqbody) => {
    const id = reqbody._id;
    const { _id, ...body } = reqbody; // remove _id from reqbody and create new object called body

    let response = await api.put("updateMasterIntroQuiz/" + id, body.body);
    return response.data;
  }
);

// export const deleteCommonQuizTopicThunk = createAsyncThunk(
//   "commonquiz/delete",
//   async (data) => {
//     let response = await api.delete(`deleteMasterIntroQuiz/${data.usertype}`);
//     return response.data;
//   }
// );

export const deleteQuizThunk = createAsyncThunk(
  "quiz/delete",
  async (params) => {
    const { usertype } = params;
    let response = await api.delete("deleteMasterIntroQuiz/" + "fellow" );
    return response.data;
  }
);